import React, { useContext } from 'react'
import { GridApi } from 'ag-grid-community'
import { clientActionDataBaseReportRequest, DealSubscriptionIdentifier, EntityTypeEnum } from 'api'
import { useDispatch } from 'react-redux'
import { createEntitySubscriptionFiltersSelector } from 'selectors/selectionSelectors'
import { GridToolbarSettings } from 'store/grid'
import { ToolbarButton } from 'view/components/buttons'
import * as gridIcons from 'view/components/datagrid/styles/gridIconSet'
import { Translation } from 'locale'
import { EnvironmentContext } from 'view/shared/environment'
import { useParametricSelector } from 'utils'

export interface ExtractReportButton {
  gridApi: GridApi | null
  toolbarSettings: GridToolbarSettings
  onToolbarSettingsChanged: (toolbarSettings: GridToolbarSettings) => unknown
}

const subscriptionFiltersSelector = createEntitySubscriptionFiltersSelector(
  () => EntityTypeEnum.DEAL,
  () => DealSubscriptionIdentifier.BLOTTER
)

export const ExtractReportButton = () => {
  const dispatch = useDispatch()
  const environment = useContext(EnvironmentContext)
  const subscriptionFilters = useParametricSelector(subscriptionFiltersSelector, null)

  return environment.isAdmin ? (
    <ToolbarButton
      onClick={() => {
        dispatch(clientActionDataBaseReportRequest(subscriptionFilters))
      }}
      tooltip={Translation.SC_EXTRACT_REPORT}>
      {gridIcons.documentIcon}
    </ToolbarButton>
  ) : null
}
